(() => {
  const banner = document.querySelector("[data-geo-store-switcher]");
  const configEl = document.getElementById("geo-store-config");
  const urlMapEl = document.getElementById("geo-store-url-map");
  const STORE_CONFIG = configEl ? JSON.parse(configEl.textContent) : {};
  const REDIRECT_CONTEXT = urlMapEl ? JSON.parse(urlMapEl.textContent) : null; 
  const isDesignMode = banner?.dataset.designMode === "true";
  const forceShow = banner?.dataset.forceShow === "true";

  const COUNTRY_TO_STORE = {
    de: "DE",
    fr: "FR",
    pl: "PL",
    gb: "UK",
    uk: "UK"
  };

  const DEFAULT_STORE = banner?.dataset.defaultStore || "DE";
  const MAIN_HOSTS = ["holy.com", "www.holy.com"];
  const PREF_COOKIE = "holy_store_pref";
  const PREF_SOURCE_COOKIE = "holy_store_pref_source";
  const EVENT_COOKIE = "holy_geo_event";
  const DISMISS_KEY = "holy_geo_banner_dismissed";
  const COOKIE_DOMAIN = ".holy.com";

  const storeSelect = document.getElementById("geo-store-select");
  const storeApply = document.getElementById("geo-store-apply");
  const closeButton = document.getElementById("geo-store-close");
  const detectedStoreLabel = document.getElementById("geo-store-detected");

  const hostname = window.location.hostname.toLowerCase();
  const currentStore = getCurrentStore(hostname);

  function getCurrentStore(host) {
    if (host.startsWith("de.")) return "DE";
    if (host.startsWith("fr.")) return "FR";
    if (host.startsWith("pl.")) return "PL";
    if (host.startsWith("uk.")) return "UK";
    if (MAIN_HOSTS.includes(host)) return "MAIN";
    return "UNKNOWN";
  }

  function setCookie(name, value, days, domain) {
    const maxAge = days ? `; max-age=${days * 24 * 60 * 60}` : "";
    const domainPart = domain ? `; domain=${domain}` : "";
    document.cookie = `${name}=${value}; path=/${maxAge}${domainPart}; SameSite=Lax`;
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function clearCookie(name, domain) {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${domain ? `; domain=${domain}` : ""}; SameSite=Lax`;
  }

  function trackEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function queueEvent(payload) {
    setCookie(EVENT_COOKIE, encodeURIComponent(JSON.stringify(payload)), 1, COOKIE_DOMAIN);
    setCookie(EVENT_COOKIE, encodeURIComponent(JSON.stringify(payload)), 1);
  }

  function consumeQueuedEvent() {
    const raw = getCookie(EVENT_COOKIE);
    if (!raw) return;

    try {
      const payload = JSON.parse(decodeURIComponent(raw));
      trackEvent(payload);
    } catch (error) {
      // ignore
    }

    clearCookie(EVENT_COOKIE, COOKIE_DOMAIN);
    clearCookie(EVENT_COOKIE);
  }

  function setPreference(storeCode, source) {
    setCookie(PREF_COOKIE, storeCode, 30, COOKIE_DOMAIN);
    setCookie(PREF_COOKIE, storeCode, 30);
    setCookie(PREF_SOURCE_COOKIE, source, 30, COOKIE_DOMAIN);
    setCookie(PREF_SOURCE_COOKIE, source, 30);
  }

  function getPreference() {
    return {
      store: getCookie(PREF_COOKIE),
      source: getCookie(PREF_SOURCE_COOKIE)
    };
  }

  function buildTargetUrl(storeCode) {
    const store = STORE_CONFIG[storeCode];
    if (!store) return null;
    return `https://${store.host}${window.location.pathname}${window.location.search}${window.location.hash}`;
  }

  function normalizeSku(value) {
    return (value || "").toString().trim().toLowerCase();
  }

  function getUrlForStore(urls, storeCode) {
    if (!urls || typeof urls !== "object") return null;
    const key = (storeCode || "").toString();
    const lowerKey = key.toLowerCase();
    const upperKey = key.toUpperCase();
    const url = urls[lowerKey] || urls[upperKey];
    return typeof url === "string" && url ? url : null;
  }

  function getCurrentProductSku() {
    if (REDIRECT_CONTEXT?.pageType !== "product") {
      return normalizeSku(REDIRECT_CONTEXT?.currentSku);
    }

    const variantSkuMap = REDIRECT_CONTEXT?.variantSkuMap;

    if (variantSkuMap && typeof variantSkuMap === "object") {
      const variantFromUrl = new URLSearchParams(window.location.search).get("variant");
      if (variantFromUrl) {
        const skuFromUrl = variantSkuMap[String(variantFromUrl)];
        if (skuFromUrl) {
          return normalizeSku(skuFromUrl);
        }
      }

      const formVariantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const selectedVariantId = formVariantInput ? formVariantInput.value : null;
      if (selectedVariantId) {
        const skuFromForm = variantSkuMap[String(selectedVariantId)];
        if (skuFromForm) {
          return normalizeSku(skuFromForm);
        }
      }
    }

    return normalizeSku(REDIRECT_CONTEXT?.currentSku);
  }

  function getMappedTargetUrl(storeCode) {
    const mappings = REDIRECT_CONTEXT?.urlMappings;
    if (!mappings) return null;

    const pageType = REDIRECT_CONTEXT?.pageType;

    if (pageType === "product") {
      if (!Array.isArray(mappings)) return null;

      const currentSku = getCurrentProductSku();
      if (!currentSku) return null;

      const matched = mappings.find((item) => normalizeSku(item?.sku) === currentSku);
      return getUrlForStore(matched?.urls, storeCode);
    }

    if (Array.isArray(mappings)) {
      const firstWithUrls = mappings.find((item) => item?.urls && typeof item.urls === "object");
      return getUrlForStore(firstWithUrls?.urls, storeCode);
    }

    if (typeof mappings === "object" && mappings?.urls) {
      return getUrlForStore(mappings.urls, storeCode);
    }

    return null;
  }

  function getRedirectUrl(storeCode) {
    const mappedUrl = getMappedTargetUrl(storeCode);
    return mappedUrl || buildTargetUrl(storeCode);
  }

  async function getDetectedCountry() {
    try {
      const response = await fetch("/browsing_context_suggestions.json", { credentials: "same-origin" });
      if (!response.ok) return null;
      const data = await response.json();
      return (data?.detected_values?.country?.handle || data?.detected_values?.country?.iso_code || "").toLowerCase();
    } catch (error) {
      return null;
    }
  }

  function renderBanner(options) {
    if (!banner) return;

    const force = options?.forceShow === true;

    if ((currentStore === "MAIN" || currentStore === "UNKNOWN") && !force) {
      banner.hidden = true;
      return;
    }

    const { detectedCountry, detectedStore } = options;
    const preference = getPreference();
    const detectedPrefix = banner.dataset.detectedPrefix || "";
    const storeForHide = detectedStore || currentStore;

    const shouldHideOnCorrectStore = storeForHide && currentStore === storeForHide && preference.source !== "manual" && !force;
    if (shouldHideOnCorrectStore) {
      banner.hidden = true;
      return;
    }

    if (!force && localStorage.getItem(DISMISS_KEY) === "true") {
      banner.hidden = true;
      return;
    }

    banner.hidden = false;

    if (detectedStoreLabel) {
      if (!detectedStore) {
        detectedStoreLabel.textContent = "";
      } else {
        const detectedName = STORE_CONFIG[detectedStore]?.name || "";
        detectedStoreLabel.textContent = detectedPrefix ? `${detectedPrefix} ${detectedName}`.trim() : detectedName;
      }
    }

    if (storeSelect) {
      storeSelect.innerHTML = "";
      Object.entries(STORE_CONFIG).forEach(([code, config]) => {
        const option = document.createElement("option");
        option.value = code;
        option.textContent = config.name;
        if (code === (detectedStore || currentStore)) option.selected = true;
        storeSelect.appendChild(option);
      });
    }

    if (storeApply) {
      storeApply.addEventListener("click", () => {
        const selectedStore = storeSelect ? storeSelect.value : currentStore;
        if (!selectedStore || selectedStore === currentStore) return;

        setPreference(selectedStore, "manual");
        queueEvent({
          event: "geo_store_switch",
          source: "manual",
          detectedCountry: detectedCountry || "unknown",
          currentStore,
          selectedStore,
          host: hostname
        });

        const targetUrl = getRedirectUrl(selectedStore);
        if (targetUrl) {
          window.location.href = targetUrl;
        }
      });
    }

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        localStorage.setItem(DISMISS_KEY, "true");
        banner.hidden = true;
      });
    }
  }

  async function init() {
    consumeQueuedEvent();

    const detectedCountry = await getDetectedCountry();
    const detectedStore = detectedCountry ? COUNTRY_TO_STORE[detectedCountry] : null;
    const preference = getPreference();

    if (isDesignMode && forceShow) {
      renderBanner({ detectedCountry, detectedStore: detectedStore || DEFAULT_STORE, forceShow: true });
      return;
    }

    if (!detectedStore) {
      trackEvent({
        event: "geo_fallback",
        detectedCountry: detectedCountry || "unknown",
        currentStore,
        host: hostname
      });
    }

    if (currentStore === "MAIN") {
      const targetStore = preference.store || detectedStore || DEFAULT_STORE;
      const targetUrl = getRedirectUrl(targetStore);
      const eventPayload = {
        event: "geo_auto_redirect",
        source: preference.store ? "preference" : "geo",
        detectedCountry: detectedCountry || "unknown",
        targetStore,
        fallback: !detectedStore,
        host: hostname
      };

      queueEvent(eventPayload);

      if (targetUrl) {
        window.location.replace(targetUrl);
      }
      return;
    }

    renderBanner({ detectedCountry, detectedStore: detectedStore || DEFAULT_STORE });
  }

  init();
})();
